<script lang="ts" setup>
import { ref, type PropType } from 'vue';
import { useResizeObserver } from '@vueuse/core';

type Level = {
  name: string,
  active: boolean
}

defineProps({
  sand: {
    type: Boolean,
    required: true
  },
  level: {
    type: Number,
    required: true
  },
  levels: {
    type: Array as PropType<Level[]>,
    required: true
  },
});

const imgRatio = 1.423659673659674;
const container = ref(null);
const widthPadding = 100;
const percentageContainerWidth = ref(0);
const percentageContainerHeight = ref(0);

const labelPlacement = [0, 0.18, 0.37, 0.55];

const levelsAssets = {
  sand: [
    '/assets/well/well_empty.jpg',
    '/assets/well/well_active_sand.jpg',
    '/assets/well/well_lev_2_sand.jpg',
    '/assets/well/well_lev_3_sand.jpg',
    '/assets/well/well_full_sand.jpg',
  ],
  noSand: [
    '/assets/well/well_empty.jpg',
    '/assets/well/well_active.jpg',
    '/assets/well/well_lev_2.jpg',
    '/assets/well/well_lev_3.jpg',
    '/assets/well/well_full.jpg',
  ]
};

useResizeObserver(container, (entries) => {
  const entry = entries[0];
  if (!entry) return;
  const { width, height } = entry.contentRect;
  const currRatio = width / height;

  if (currRatio < imgRatio)
  {
    percentageContainerWidth.value = height * 0.31 + widthPadding;
    percentageContainerHeight.value = height * 0.68;
  }
  else
  {
    percentageContainerWidth.value = width * 0.20 + widthPadding;
    percentageContainerHeight.value = width * 0.488;
  }
});

</script>

<template>
  <div
    ref="container"
    class="h-full w-full overflow-hidden bg-cover bg-center bg-no-repeat"
  >
    <img
      class="w-full h-full object-cover"
      :src="levelsAssets[sand ? 'sand' : 'noSand'][level]"
    >
    <div
      class="absolute top-[44%] translate-y-[-50%] left-[50%] w-[200px] translate-x-[-50%] flex"
      :style="`width: ${percentageContainerWidth}px; height: ${percentageContainerHeight}px;`"
    >
      <div
        class="h-full flex justify-between flex-col-reverse"
      >
        <div
          class="relative h-full flex-1 flex "
          :style="`margin-bottom: ${percentageContainerHeight/8}px`"
        >
          <p
            v-for="currLevel, i in levels"
            :key="i"
            :class="currLevel.active ? 'text-foreground' : 'text-muted-foreground'"
            :style="`position: absolute; bottom: ${(labelPlacement[i] ?? 0) * percentageContainerHeight}px;`"
          >
            {{ currLevel.name }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
